<!-- Container Starts -->
<div class="questionText">
  <legend class="removeBorder">
  <span [id]="question.id" class="What-have-you-smoked"> {{question.questionText}} </span>
</legend>
</div>

<!--[id]="question.questionText)" -->
<div class="info-for-para-text">
  <app-tool-tip-notification [uwQuesForWA]="question" (lifestyleInfoEmitter)="lifestyleInfoReceiver($event)" [childId]="'tallinfo'" [tooltipData]="tooltipObj" 
  (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver()"></app-tool-tip-notification>
</div>

<div [formGroup]="parent" class="row col-md-12 clear-all grid-container mar-left">
  <ng-container *ngFor="let gridTile of gridTiles;let i=index">
    <!-- <div class="col-md-5 clear-all width-45" [ngClass]="{'margin-bottom-30': (i===1), 'margin-bottom-30': (i===1  && parent.get(gridTile.id).touched
    && parent.get(gridTile.id).errors && !parent.get(gridTile.id).valid) }"> -->
    <div class="col-md-5 clear-all width-45" [ngClass]="{'clear-both':(i===2)}">
      <div class="clear-all">
        <div class="clear-all">
          <div class="col-md-12 clear-all">
            <div class="container bigContainer5">
              <div class="col-md-12 clear-all">
                <div class="col-md-12">
                  <div class="col-md-3 mob-tab-container">
                    <img [id]="'img-'+gridTile.id" src="{{gridTile.imagePath}}" alt="" class="Alcopop">
                  </div>
                  <div class="col-md-2 mar-t mob-tab-container" *ngIf="gridTile.controlType === 'InputBox'">
                    <input [formControlName]="gridTile.id" [attr.aria-label]="gridTile.questionText?gridTile.questionText:gridTile.id" [(ngModel)]="gridTile.responseValueByUser"
                      id="{{gridTile.id}}-input" type="text" class="text-input btn-border" OnlyNumber="true" minValue="0" maxlength="3"
                      [maxValue]="gridTile.responseRange" isCurrency="false" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      inputmode="numeric"
                      />
                  </div>
                  <div class="col-md-7 Glasses-of-Wine ">
                    <span [ngClass]="(gridTile.questionText.length < 16 && !gridTile.questionLabel) ? 'middle-align': ''" [id]="gridTile.id">{{gridTile.questionText}} </span>
                    <p id="{{gridTile.id}}-label" class="per-day mt-3">{{gridTile.questionLabel}}</p>
                  </div>

                </div>
                <div class="col-md-12">
                  <div class="row margin-toggle-top" *ngIf="gridTile.controlStyle === 'Toggle_standard'">
                    <div class="middleLine"></div>
                    <div class="row flex-content">

                      <div class="col-md-2 mar-t-tb" *ngIf="getDependetQueForTb(gridTile)">
                        <input [formControlName]="getDependetQueIDForTb(gridTile)" id="{{getDependetQueIDForTb(gridTile)}}-input" type="text" class="text-input btn-border"
                          OnlyNumber="true" minValue="0" maxlength="3" [attr.aria-label]="gridTile.questionText?gridTile.questionText:none" [maxValue]="getDependetQueResponseRange(gridTile)" isCurrency="false"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
                      </div>

                      <div class="col-md-2 mar-t-tb">
                        <app-radio-toggle-button-new (toggleChangeEvt)="toggleChangeEvtHandler($event, gridTile)" [questionId]="gridTile.id" [config]="gridTile" 
                        [parent]="parent" [parentControlName]="gridTile.id" [editMode] = "editMode" (editModelHandler)="emitEditAlert($event)">
                        </app-radio-toggle-button-new>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div *ngIf="checkErrorValidation(gridTile)" class="col-md-5 form-validation-error">
              <i class="icon icon-error" aria-hidden="true"></i>
              <p [id]="'fundValue-error'">
                Please enter a value
              </p>
            </div>

          </div>

        </div>

      </div>

    </div>
    <div *ngIf="i%2 === 0" class="col-md-1 width-10"></div>
  </ng-container>
  <div *ngIf="gridMaxReachedError" class="col-md-5 form-validation-error text-left gridError">
    <i class="icon icon-error" aria-hidden="true"></i>
    <p>
      The maximum value for units of Alcohol per week is 999. A 175 ml glass of wine typically contains 2 units of alcohol and a add bottle 9 units, One 25ml standard shot of spirit or 1 Alcopop contains 1 unit, 1 pint of beer or cider contains 2 units
    </p>
  </div>
</div>

<!-- Container Ends -->